import React, { useState } from 'react';
import { auth } from '../firebase';

const SetAdmin = () => {
  const [uid, setUid] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSetAdmin = async () => {
    if (!uid.trim()) {
      setMessage('لطفاً UID کاربر را وارد کنید');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // Get current user token
      const user = auth.currentUser;
      if (!user) {
        setMessage('کاربر وارد نشده است');
        return;
      }

      const token = await user.getIdToken();
      
      // Call Cloud Function via HTTP
      const response = await fetch(`https://empty-rain-2654.er-hooman.workers.dev/api/firebase/setAdminRole`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ uid: uid.trim() })
      });

      if (response.ok) {
        const result = await response.json();
        setMessage('نقش ادمین با موفقیت تنظیم شد!');
        console.log('Set admin result:', result);
      } else {
        const error = await response.text();
        setMessage(`خطا: ${error}`);
      }
    } catch (error) {
      setMessage(`خطا: ${error.message}`);
      console.error('Error setting admin:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveAdmin = async () => {
    if (!uid.trim()) {
      setMessage('لطفاً UID کاربر را وارد کنید');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // Get current user token
      const user = auth.currentUser;
      if (!user) {
        setMessage('کاربر وارد نشده است');
        return;
      }

      const token = await user.getIdToken();
      
      // Call Cloud Function via HTTP
      const response = await fetch(`https://empty-rain-2654.er-hooman.workers.dev/api/firebase/removeAdminRole`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ uid: uid.trim() })
      });

      if (response.ok) {
        const result = await response.json();
        setMessage('نقش ادمین با موفقیت حذف شد!');
        console.log('Remove admin result:', result);
      } else {
        const error = await response.text();
        setMessage(`خطا: ${error}`);
      }
    } catch (error) {
      setMessage(`خطا: ${error.message}`);
      console.error('Error removing admin:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentUserUid = () => {
    const user = auth.currentUser;
    if (user) {
      setUid(user.uid);
      setMessage('UID کاربر فعلی کپی شد');
    } else {
      setMessage('کاربر وارد نشده است');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-lg shadow-md p-6 w-full max-w-md">
        <h1 className="text-2xl font-bold text-center mb-6">تنظیم نقش ادمین</h1>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              UID کاربر:
            </label>
            <input
              type="text"
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              placeholder="UID کاربر را وارد کنید"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex space-x-2 space-x-reverse">
            <button
              onClick={getCurrentUserUid}
              className="flex-1 px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors"
            >
              کپی UID فعلی
            </button>
          </div>

          <div className="flex space-x-2 space-x-reverse">
            <button
              onClick={handleSetAdmin}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors disabled:opacity-50"
            >
              {loading ? 'در حال تنظیم...' : 'تنظیم ادمین'}
            </button>
            
            <button
              onClick={handleRemoveAdmin}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors disabled:opacity-50"
            >
              {loading ? 'در حال حذف...' : 'حذف ادمین'}
            </button>
          </div>

          {message && (
            <div className={`p-3 rounded-md text-sm ${
              message.includes('خطا') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
            }`}>
              {message}
            </div>
          )}

          <div className="text-xs text-gray-500 mt-4">
            <p><strong>نکات مهم:</strong></p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>ابتدا کاربر باید ثبت‌نام کرده باشد</li>
              <li>UID را از Firebase Console یا دکمه "کپی UID فعلی" بگیرید</li>
              <li>بعد از تنظیم نقش، کاربر باید دوباره وارد شود</li>
              <li>این صفحه فقط برای تست است</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetAdmin;
